export default {
  inserted: (el, binding, vnode) => {
    el.style.position = 'relative';
    const { clientWidth, clientHeight } = el;
    const { value: parameters } = binding;
    let radius = parameters && parameters.radius ? parameters.radius : 10;
    const thickness = parameters && parameters.thickness ? parameters.thickness : 1;
    // const paddingTop = parseFloat(window.getComputedStyle(el).getPropertyValue('padding-top'));
    // const paddingRight = parseFloat(window.getComputedStyle(el).getPropertyValue('padding-right'));
    // const paddingBottom = parseFloat(window.getComputedStyle(el).getPropertyValue('padding-bottom'));
    // const paddingLeft = parseFloat(window.getComputedStyle(el).getPropertyValue('padding-left'));
    const color = parameters && parameters.color ? parameters.color : '#2680eb';

    if (((radius * 2 + thickness) > clientHeight) || (radius * 2 > clientWidth)) {
      radius = clientHeight > clientWidth ? clientWidth / 2 - thickness / 2 : clientHeight / 2 - thickness / 2;
    }

    // console.log('Width:', clientWidth);
    // console.log('Height:', clientHeight);
    // console.log('Padding:', paddingTop, paddingRight, paddingBottom, paddingLeft);
    // console.log('Radius:', radius);
    // console.log('Thickness:', thickness);
    // console.log('Color:', color);

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.id = 'sb-progress-wrapper';
    svg.style.position = 'absolute';
    svg.style.width = `${clientWidth}px`;
    svg.style.height = `${clientHeight}px`;
    svg.style.top = 0;
    svg.style.left = 0;
    svg.version = '1.1';

    el.appendChild(svg);

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('fill', 'transparent');
    path.setAttribute('stroke', color);
    path.setAttribute('stroke-width', thickness);
    path.setAttribute('pathLength', 100);
    path.style.strokeDasharray = 100;
    path.style.strokeDashoffset = binding.value && binding.value.progress ? 100 - binding.value.progress : 100;
    path.style.transition = '.5s linear';
    path.setAttribute('d', `
      M ${clientWidth / 2},${thickness / 2}
      h ${clientWidth / 2 - radius - thickness / 2}
      C ${clientWidth - radius / 2 - thickness / 2},${thickness / 2} ${clientWidth - thickness / 2},${radius / 2 + thickness / 2} ${clientWidth - thickness / 2},${radius + thickness / 2}
      v ${clientHeight - radius * 2 - thickness}
      C ${clientWidth - thickness / 2},${clientHeight - radius / 2 - thickness / 2} ${clientWidth - radius / 2 - thickness / 2},${clientHeight - thickness / 2} ${clientWidth - radius - thickness / 2},${clientHeight - thickness / 2}
      h -${clientWidth - radius * 2 - thickness}
      C ${radius / 2 + thickness / 2},${clientHeight - thickness / 2} ${thickness / 2},${clientHeight - radius / 2 - thickness / 2} ${thickness / 2},${clientHeight - radius - thickness / 2}
      v -${clientHeight - radius * 2 - thickness}
      C ${thickness / 2},${radius / 2 + thickness / 2} ${radius / 2 + thickness / 2},${thickness / 2} ${radius + thickness / 2},${thickness / 2}
      z
    `);

    svg.appendChild(path);
  },
  update: (el, binding) => {
    if (binding.value && binding.value.progress) {
      el.childNodes[el.childNodes.length - 1].childNodes[0].style.strokeDashoffset = 100 - binding.value.progress;
    }
  },
  componentUpdated: (el, binding) => { },
};
